import Link from 'next/link';
import styled from 'styled-components';
import { useSelector } from 'src/store/store';
import i18n from 'src/utils/translate';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event, Section } from 'src/constants/footfall';
import NavBar from 'src/components/navBar';
import { ProfileTab } from 'src/constants/types';
import { useMediaQuery } from 'src/utils/mediaQuery';
export default function ProfileNavbar() {
  const {
    currentTab,
    profileUser: {
      username,
      isOwnProfile
    }
  } = useSelector(({
    pages
  }) => pages.profile);
  const isMobile = useMediaQuery('underScreenMedium');
  const trackTabNavigation = (item: string) => {
    trackFootfallEvent(Event.Clicked, {
      clickType: `${item}-tab`,
      clickMetadata: {
        section: Section.ProfileNavbar,
        origin: isOwnProfile ? 'own-profile' : 'other-profile'
      }
    });
  };
  return <StyledNavBar isCompact={true} data-sentry-element="StyledNavBar" data-sentry-component="ProfileNavbar" data-sentry-source-file="profileNavbar.tsx">
      {isMobile && <Link as={`/user/${username}`} className={currentTab === ProfileTab.About ? 'active' : ''} href={`/user/profile?username=${username}`} onClick={() => trackTabNavigation(ProfileTab.About)}>
          {i18n.t('About')}
        </Link>}
      <Link as={`/user/${username}/posts`} className={currentTab === ProfileTab.Posts ? 'active' : ''} href={`/user/profile?username=${username}&page=posts`} onClick={() => trackTabNavigation(ProfileTab.Posts)} data-sentry-element="Link" data-sentry-source-file="profileNavbar.tsx">
        {i18n.t('Posts')}
      </Link>
      <Link as={`/user/${username}/replies`} className={currentTab === ProfileTab.Replies ? 'active' : ''} href={`/user/profile?username=${username}&page=replies`} onClick={() => trackTabNavigation(ProfileTab.Replies)} data-sentry-element="Link" data-sentry-source-file="profileNavbar.tsx">
        {i18n.t('Replies')}
      </Link>
      <Link as={`/user/${username}/connections`} className={currentTab === ProfileTab.Connections ? 'active' : ''} href={`/user/profile?username=${username}&page=connections`} onClick={() => trackTabNavigation(ProfileTab.Connections)} data-sentry-element="Link" data-sentry-source-file="profileNavbar.tsx">
        {i18n.t('Connections')}
      </Link>
    </StyledNavBar>;
}
const StyledNavBar = styled(NavBar)`
  margin-bottom: 20px;
  @media (${({
  theme
}) => theme.underScreenSmall}) {
    margin: 0 15px 20px 15px;
  }
`;